import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { InteractiveElement } from "@iventis/styles/src/components";
import { TypographyColorsEnum } from "@iventis/styles/src/style.types";
import { Subtitle, Body2 } from "@iventis/styles/src/components/texts";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { styled } from "@iventis/styles";
import { Content } from "@iventis/translations/content/typed-content";
import { useIventisTranslate } from "@iventis/translations/use-iventis-translate";
import { RootDispatch, RootState } from "./state/root.store";
import { sidebar } from "./state/sidebar.slice";
import { MapInterfaceStyle } from "./state/sidebar.slice.types";
import { RowFormattedPopover } from "./popover-row-format";

export const MapSettingsComponent = () => {
    const { mapInterfaceStyle } = useSelector((s: RootState) => s.sidebarReducer);
    const dispatch: RootDispatch = useDispatch();
    const translate = useIventisTranslate();

    const getInterfaceStyleText = (style: MapInterfaceStyle) => {
        if (style === MapInterfaceStyle.COMPRESSED) {
            return translate(Content.map12.map_settings.compressed);
        }

        return translate(Content.map12.map_settings.spacious);
    };

    return (
        <>
            <RowFormattedPopover>
                <StyledSubtitle color={TypographyColorsEnum.CORE}>{translate(Content.map12.map_settings.interface_style)}</StyledSubtitle>
                {Object.values(MapInterfaceStyle).map((style) => (
                    <StyledSelector key={style} type="button" onClick={() => dispatch(sidebar.actions.setInterfaceStyle(style))}>
                        <div id="tick">{style === mapInterfaceStyle && <FontAwesomeIcon icon={["far", "check"]} />}</div>
                        <Body2>{getInterfaceStyleText(style)}</Body2>
                    </StyledSelector>
                ))}
            </RowFormattedPopover>
        </>
    );
};

const StyledSubtitle = styled(Subtitle)`
    text-align: center;
    align-self: center;
    padding: 0 1rem;
`;

const StyledSelector = styled(InteractiveElement)`
    padding: 0 2rem;
    display: flex;
    align-items: center;
    position: relative;
    #tick {
        position: absolute;
        left: 0.75rem;
    }
`;
